const createVerticalGradient = (ctx, chartArea, color, maxAlpha = 0.35) => {
  let colourValue = color;
  if (colourValue.charAt(0) === "#") {
    colourValue = hexToRgb(colourValue);
  }

  const gradient = ctx.createLinearGradient(
    0,
    chartArea.top,
    0,
    chartArea.bottom
  );

  gradient.addColorStop(0, `rgba(${colourValue}, ${maxAlpha})`);
  gradient.addColorStop(1, `rgba(${colourValue}, 0)`);

  return gradient;
};

const hexToRgb = (hex) => {
  const h = hex.replace("#", "");
  const bigint = parseInt(h, 16);
  return `${(bigint >> 16) & 255}, ${(bigint >> 8) & 255}, ${bigint & 255}`;
};

export { createVerticalGradient, hexToRgb };
